import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Accountbranch} from '../accountbranch';
import {AccountbranchService} from '../accountbranch.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RecordDataComponent} from "../../../../components/record-data";
import {Tax} from "../../../setting/taxes/tax";
import {AppArcComponent} from '../../../../components/app-arc';
import {OrganizationShowComponent} from "../../../setting/organization/organization-show/organization-show.component";
import {AccountsService} from '../../../fin/accounts/accounts.service';
import {CostcentersService} from '../../../fin/costcenters/costcenters.service';
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";

import {StoreService} from '../../../setting/stores/store.service';
import {UserService} from '../../../../services';
import {CityService} from '../../../setting/cities/cities.service';
import {BranchService} from '../../../setting/branches/branch.service';
import {CustomersShowComponent} from '../../../setting/customers/customers-show/customers-show.component';
import {BranchesShowComponent} from '../../../setting/branches/branches-show/branches-show.component';
import {AccountsShowComponent} from '../../accounts/accounts-show/accounts-show.component';
import {CostcentersShowComponent} from '../../costcenters/costcenters-show/costcenters-show.component';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        TranslateModule.forChild()
    ],
    declarations: [
        AccountbranchesShowComponent
    ],
    entryComponents: [
        AccountbranchesShowComponent
    ],
    exports: [],
    providers: [SharedService, AccountbranchService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})
@Component({
    selector: 'app-accountbranches-show',
    templateUrl: './accountbranches-show.component.html',
    styleUrls: ['./accountbranches-show.component.scss'],
    providers: [AccountbranchService, ConfirmationService, MessageService]
})


export class AccountbranchesShowComponent implements OnInit, AfterViewInit {

    id: string;
    accountbranch = new Accountbranch();
    filter: any;
    parent: any;
    @Input() delId;
    @Input() scrId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() modelName;
    modalRef: NgbModalRef;

    alltreeacc: any[] = [];
    alltreecost: any[] = [];
    allusers: any[] = [];
    allcities: any[] = [];
    allstores: any[] = [];
    parentAccounts: any[] = [];
    branchForm: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];

    private _editButton: any;
    private _deleteButton: any;
    private _searchButton: any;
    private _newButton: any;
    private _printButton: any;
    hiddenFields: any[] = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private branchService: AccountbranchService,
                private branService: BranchService,
                private accountsService: AccountsService,
                private coctcenterService: CostcentersService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
                    this.msgs = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(AccountbranchesShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('accountbranches');
    }

  showParent(){
    console.log(this.parent);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        //
        return true;
      }
    };
    this.modalRef = this.modalService.open(BranchesShowComponent, options);
    this.modalRef.componentInstance.scrId = this.parent;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }

    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();

                return true;
            }
        };
        JSON.parse(localStorage.getItem('filter'));

        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.accountbranch;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
      if(!this.scrId && !this.oldData && !this.scrId) {

            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._searchButton = document.getElementById('searchButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');

            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/accountbranches/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteAccountbranch(this.accountbranch);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/accountbranches']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/accountbranches/search']);
                });
            }
        }
    }

    ngOnInit() {
      this.accountsService.getParents().subscribe(
        group => {
          this.parentAccounts = group;
        });
      
      this.accountsService.getAllGroups(0).subscribe(
        group => {
          this.alltreeacc = group;
        });
      this.coctcenterService.getAllGroups(0).subscribe(
        group => {
          this.alltreecost = group;
        });

      this.branService.getAllBranches().subscribe(
        group => {
          this.allstores = group.brancheslist;
        });


        this.msgs=[];
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.branchForm = new FormGroup({

          id: new FormControl({value: '', disabled: true}),
          costcenter_id: new FormControl({value: '', disabled: true}),
          sales_no_tax_acc_code: new FormControl({value: '', disabled: true}),
          sales_tax_acc_code: new FormControl({value: '', disabled: true}),
          discount_acc_code: new FormControl({value: '', disabled: true}),
          sales_return_no_tax_acc_code: new FormControl({value: '', disabled: true}),
          sales_return_tax_acc_code: new FormControl({value: '', disabled: true}),
          payment_no_tax_acc_code: new FormControl({value: '', disabled: true}),
          payment_tax_acc_code: new FormControl({value: '', disabled: true}),
          payment_return_no_tax_acc_code: new FormControl({value: '', disabled: true}),
          payment_return_tax_acc_code: new FormControl({value: '', disabled: true}),
          bank_acc_cash: new FormControl({value: '', disabled: true}),
          bank_acc_transfers: new FormControl({value: '', disabled: true}),
          bank_acc_creditcards: new FormControl({value: '', disabled: true}),
          bank_acc_atmcards: new FormControl({value: '', disabled: true}),
          additional_tax_acc_code: new FormControl({value: '', disabled: true}),
          other_tax_acc_code: new FormControl({value: '', disabled: true}),
          cashier_acc_code: new FormControl({value: '', disabled: true}),
          customers_acc_code: new FormControl({value: '', disabled: true}),
          suppliers_acc_code: new FormControl({value: '', disabled: true}),
          representative_acc_code: new FormControl({value: '', disabled: true}),
          bank_acc_points_and_vouchers: new FormControl({value: '', disabled: true}),
        });

        this.fieldsControl('setting.accountbranches');

        if (this.id) {
            this.msgs=[];
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.newDatap = true;

            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs=[];
            }
            this.branchService.getById(this.id).subscribe(
                accountbranch => {
                    this.id = accountbranch.id;
                    this.parent = accountbranch.id;
                    this.accountbranch = accountbranch;
                    this.branchForm.patchValue({
                      id: accountbranch.id,
                      costcenter_id: accountbranch.costcenter_id,
                      sales_no_tax_acc_code: accountbranch.sales_no_tax_acc_code,
                      sales_tax_acc_code: accountbranch.sales_tax_acc_code,
                      sales_return_no_tax_acc_code: accountbranch.sales_return_no_tax_acc_code,
                      payment_no_tax_acc_code: accountbranch.payment_no_tax_acc_code,
                      payment_return_no_tax_acc_code: accountbranch.payment_return_no_tax_acc_code,
                      bank_acc_cash: accountbranch.bank_acc_cash,
                      bank_acc_transfers: accountbranch.bank_acc_transfers,
                      bank_acc_creditcards: accountbranch.bank_acc_creditcards,
                      bank_acc_atmcards: accountbranch.bank_acc_atmcards,
                      additional_tax_acc_code: accountbranch.additional_tax_acc_code,
                      other_tax_acc_code: accountbranch.other_tax_acc_code,
                      cashier_acc_code: accountbranch.cashier_acc_code,
                      customers_acc_code: accountbranch.customers_acc_code,
                      suppliers_acc_code: accountbranch.suppliers_acc_code,
                      representative_acc_code: accountbranch.representative_acc_code,
                      bank_acc_points_and_vouchers: accountbranch.bank_acc_points_and_vouchers,
                      status: accountbranch.status,
                    });
                }, error => {
                    console.log(error);
                }
            );

        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;

            this.delId = false;

            this.branchService.getById(this.scrId).subscribe(
                accountbranch => {
                    this.id = accountbranch.id;
                    this.parent = accountbranch.id;
                    this.accountbranch = accountbranch;
                    this.branchForm.patchValue({
                      id: accountbranch.id,
                      costcenter_id: accountbranch.costcenter_id,
                      sales_no_tax_acc_code: accountbranch.sales_no_tax_acc_code,
                      sales_tax_acc_code: accountbranch.sales_tax_acc_code,
                      sales_return_no_tax_acc_code: accountbranch.sales_return_no_tax_acc_code,
                      payment_no_tax_acc_code: accountbranch.payment_no_tax_acc_code,
                      payment_return_no_tax_acc_code: accountbranch.payment_return_no_tax_acc_code,
                      bank_acc_cash: accountbranch.bank_acc_cash,
                      bank_acc_transfers: accountbranch.bank_acc_transfers,
                      bank_acc_creditcards: accountbranch.bank_acc_creditcards,
                      bank_acc_atmcards: accountbranch.bank_acc_atmcards,
                      additional_tax_acc_code: accountbranch.additional_tax_acc_code,
                      other_tax_acc_code: accountbranch.other_tax_acc_code,
                      cashier_acc_code: accountbranch.cashier_acc_code,
                      customers_acc_code: accountbranch.customers_acc_code,
                      suppliers_acc_code: accountbranch.suppliers_acc_code,
                      representative_acc_code: accountbranch.representative_acc_code,
                      bank_acc_points_and_vouchers: accountbranch.bank_acc_points_and_vouchers,

                        status: accountbranch.status,
                    });
                }, error => {
                    console.log(error);
                }
            );

        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
          this.newDatap = !this.newDatap ;

            this.branchService.getTrashedById(this.delId).subscribe(
                accountbranch => {
                    this.id = accountbranch.id;
                  this.parent = accountbranch.id;
                    this.accountbranch = accountbranch;
                    this.branchForm.patchValue({
                      id: accountbranch.id,
                      costcenter_id: accountbranch.costcenter_id,
                      sales_no_tax_acc_code: accountbranch.sales_no_tax_acc_code,
                      sales_tax_acc_code: accountbranch.sales_tax_acc_code,
                      sales_return_no_tax_acc_code: accountbranch.sales_return_no_tax_acc_code,
                      payment_no_tax_acc_code: accountbranch.payment_no_tax_acc_code,
                      payment_return_no_tax_acc_code: accountbranch.payment_return_no_tax_acc_code,
                      bank_acc_cash: accountbranch.bank_acc_cash,
                      bank_acc_transfers: accountbranch.bank_acc_transfers,
                      bank_acc_creditcards: accountbranch.bank_acc_creditcards,
                      bank_acc_atmcards: accountbranch.bank_acc_atmcards,
                      additional_tax_acc_code: accountbranch.additional_tax_acc_code,
                      other_tax_acc_code: accountbranch.other_tax_acc_code,
                      cashier_acc_code: accountbranch.cashier_acc_code,
                      customers_acc_code: accountbranch.customers_acc_code,
                      suppliers_acc_code: accountbranch.suppliers_acc_code,
                      representative_acc_code: accountbranch.representative_acc_code,
                      bank_acc_points_and_vouchers: accountbranch.bank_acc_points_and_vouchers,
                      status: accountbranch.status,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.accountbranch = this.newData;
            this.parent = this.newData.id;
            this.branchForm.patchValue({
              id: this.newData.id,
              costcenter_id: this.newData.costcenter_id,
              sales_no_tax_acc_code: this.newData.sales_no_tax_acc_code,
              sales_tax_acc_code: this.newData.sales_tax_acc_code,
              sales_return_no_tax_acc_code: this.newData.sales_return_no_tax_acc_code,
              payment_no_tax_acc_code: this.newData.payment_no_tax_acc_code,
              payment_return_no_tax_acc_code: this.newData.payment_return_no_tax_acc_code,
              bank_acc_cash: this.newData.bank_acc_cash,
              bank_acc_transfers: this.newData.bank_acc_transfers,
              bank_acc_creditcards: this.newData.bank_acc_creditcards,
              bank_acc_atmcards: this.newData.bank_acc_atmcards,
              additional_tax_acc_code: this.newData.additional_tax_acc_code,
              other_tax_acc_code: this.newData.other_tax_acc_code,
              cashier_acc_code: this.newData.cashier_acc_code,
              customers_acc_code: this.newData.customers_acc_code,
              suppliers_acc_code: this.newData.suppliers_acc_code,
              representative_acc_code: this.newData.representative_acc_code,
              bank_acc_points_and_vouchers: this.newData.bank_acc_points_and_vouchers,
              status: this.newData.status
            });
        }
    }

    fieldsControl(screen: string = '') {
        if (screen === '') {
            return;
        }
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (!userdata.fields) {
            this.hiddenFields = [];
        } else {
            this.hiddenFields = (userdata.fields.screens[screen]) ? userdata.fields.screens[screen] : [];
        }

    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.accountbranches.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteAccountbranch(accountbranch: Accountbranch) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (accountbranch) {
                    this.branchService.delete(accountbranch.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(() => {
                                this.router.navigate(['/accountbranches']);
                            }, 1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));

                        }
                    );
                }
            }
        });
    }

    recoverEdit(accountbranch: Accountbranch) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (accountbranch) {
                    this.branchService.update(accountbranch).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/accountbranches/show', accountbranch.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.branchService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/accountbranches/list']);
                        }
                    );
                }
            }
        });
    }

    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    // this.changePicUrl();
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.refShow = AccountbranchesShowComponent;

        }
    }

    showAccount(fieldname:string) {
      if(!fieldname) return;
      if(!this.branchForm.controls[fieldname].value) return;
      const options: NgbModalOptions = {

        beforeDismiss: () => {

          return true;
        }
      };
      this.modalRef = this.modalService.open(AccountsShowComponent, options);
      this.modalRef.componentInstance.scrId = this.branchForm.controls[fieldname].value;

      this.modalRef.result.then(() => {
        this.activeModal.dismiss('done');
      }, () => {

      });
    }

    showCostCenter(costCenter:string) {
      if(!costCenter) return;
      if(!this.branchForm.controls[costCenter].value) return;
      const options: NgbModalOptions = {

        beforeDismiss: () => {

          return true;
        }
      };
      this.modalRef = this.modalService.open(CostcentersShowComponent, options);
      this.modalRef.componentInstance.scrId = this.branchForm.controls[costCenter].value;

      this.modalRef.result.then(() => {
        this.activeModal.dismiss('done');
      }, () => {

      });
    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/accountbranches/accountbranches-show/accountbranches-show.component.ts